// extracted by mini-css-extract-plugin
export default {"component-wrapper":"component-wrapper-83e2","text-wrapper":"text-wrapper-7122","title":"title-b6ed","subtitle":"subtitle-f5a3"};